import { getSpotsV2 } from 'api/spot'
import { clientFetch } from 'lib/fetch/client'
import { useLocale } from 'next-intl'
import { useEffect, useState } from 'react'
import { fetchSpots } from 'server-actions/fetch-spots'
import { useInitialSpotIdsStore } from 'store/global/initial-spot-ids'
import type { ISpotV2WithFullContent } from 'type/spot'

const useSpots = (spotIds: string) => {
  const hasSpots = spotIds.length > 0
  const locale = useLocale()
  const [loading, setLoading] = useState(() => hasSpots)
  const [spotList, setSpotList] = useState<ISpotV2WithFullContent[]>([])

  useEffect(() => {
    if (!hasSpots) return

    let isCurrent = true
    const fetchPostList = async () => {
      const { data } = await getSpotsV2(clientFetch, spotIds, locale)
      const spots = await fetchSpots(data, locale)
      if (!isCurrent) return
      setSpotList(spots)
      setLoading(false)
    }
    fetchPostList()
    useInitialSpotIdsStore.getState().setInitialSpotIds('')

    return () => {
      isCurrent = false
    }
  }, [hasSpots, locale, spotIds])

  return {
    loading,
    spotList
  }
}

export default useSpots
